// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__Xp5nt","bannerLink":"Banner_bannerLink__LdVBA"};